

























import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import FormHeader from '../../molecules/FormHeader.vue'

export default createComponent({
  setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    const customerId = window.location.pathname.split('/')[4]
    const jobId = window.location.pathname.split('/')[6]  
    const commonId = window.location.pathname.split('/')[8]  
    const dialogUnlike = computed(() => displayui.dialogUnlikeUser);
    const unlikeUser = async (customer_id: string) => {
      displayui.closeDialogUnlikeUser()
      await company.unlikeUser(customer_id,jobId) as any;
    }
    const closeDialog = computed(() => displayui.closeDialogUnlikeUser);
   
    return {
      customerId,
      unlikeUser,
      dialogUnlike,
      closeDialog
    };
  },

  components : {
    FormHeader,
  },
})
